import { ENVELOPE_PURPOSE } from "constant";
import { atom } from "recoil";

export type IPurpose = "selfsign" | "workflow" | "signAgreement" | "accreditation" | "multisignAgreement"

export const EnvelopePurposeState = atom<IPurpose>({
    key: "envelope-purpose-state-key",
    default: ENVELOPE_PURPOSE.WORKFLOW
})